export default __webpack_public_path__ + "static/media/carousel1.6611b72e.jpg";